import React from 'react';
import { createRoot } from 'react-dom/client';
import ContactForm from './components/ContactForm';

const rootElement = document.getElementById('reactContactFormContainer');
const site = rootElement.dataset.site;

const root = createRoot(rootElement);

root.render(<ContactForm site={site} />);
